import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'semantic';
import { Formik, FormikState } from 'formik';
import * as Yup from 'yup';

import WrappedModal from 'components/modal/WrappedModal';

type Props = {
  trigger: React.ReactNode;
  onSubmit: (newChargingGroupId: string) => void;
  type: 'create' | 'edit';
  values?: FormikState<{}>['values'];
};

export function ChargingGroupUpsertModal({
  values,
  trigger,
  onSubmit,
  type,
}: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  const initialValues: {} = {};

  return (
    <WrappedModal isOpen={isOpen} setIsOpen={setIsOpen} trigger={trigger}>
      <Formik
        initialValues={values || initialValues}
        validationSchema={Yup.object({})}
        onReset={() => setIsOpen(false)}
        onSubmit={() => {
          setIsOpen(false);
          onSubmit('mock-id');
        }}>
        {({ handleSubmit, handleReset }) => (
          <>
            <Modal.Header>
              {type === 'create'
                ? t(
                    'chargingGroupModal.createChargingGroupTitle',
                    'New Charging Group'
                  )
                : t(
                    'chargingGroupModal.editChargingGroupTitle',
                    'Edit Charging Group'
                  )}
            </Modal.Header>
            <Modal.Content>TODO</Modal.Content>
            <Modal.Actions>
              <Button
                content={t('chargingGroupModal.cancelButton', 'Cancel')}
                as="button"
                basic
                onClick={handleReset}
              />
              <Button
                content={
                  type === 'create'
                    ? t(
                        'chargingGroupModal.createButton',
                        'Create Charging Group'
                      )
                    : t(
                        'chargingGroupModal.updateButton',
                        'Update Charging Group'
                      )
                }
                as="button"
                style={{ marginLeft: '0' }}
                onClick={handleSubmit}
              />
            </Modal.Actions>
          </>
        )}
      </Formik>
    </WrappedModal>
  );
}
